import React, { useRef, useEffect, useState, } from "react";
import "reactflow/dist/style.css";
import './Subflow Template Creation.css';
import WorkflowCanvas from "../../Common Components/Workflow_Canvas";
import CanvasHeader from "../../Common Components/Canvas_Header";
import SubflowTemplateServiceController from "../../../Controllers/SubflowTemplateService";
import CustomToaster, { notify } from "../../Common Components/Custom_Toaster";
import EventServiceController from "../../../Controllers/EventService";
import NoLevelPopup from "../../Common Components/NoLevelPopup";
import LoadingOverlay from "../../Common Components/Loading_Overlay";
import WorkflowCanvasSub from "../../Common Components/Workflow_CanvasSub";
import CalloutNamePopup from "../../Common Components/Event_Callotname_Popup";

const SubflowTemplateCreation = ({ subflowTempId, subflowTempName, subflowReqBody, onBackClick, json, isSubflow, workflowName, level, isEditSubflow, handleSubflowCanvasClick, createEvent, isCloneSubflow }) => {
  const [workflowData, setWorkflowData] = useState(null);
  const [svgData, setSvgData] = useState(null);
  const [workFlow, setWorkFlow] = useState(workflowName);
  const [Level, setLevel] = useState(level);
  const workflowCanvasRef = useRef(null);
  const [subflowTemplateName, setSubflowTemplateName] = useState(subflowTempName ?? '');
  const [workFlowId, setWorkFlowId] = useState("0");
  const [levelId, setLevelId] = useState("0");
  const [emptyDropdown, setEmptyDropdown] = useState(false);
  const [dropdownData, setDropdownData] = useState({});
  const [selectedValues, setSelectedValues] = useState({
    selectedWorkflow: json.dropdownData?.workflowName ?? {},
    selectedLevel: json.dropdownData?.level ?? {}
  });
  const [eventId, seteventId] = useState(null);
  const [labelName, setlabelNames] = useState(null);
  const [dropdownEventLevelData, setEventLevelDropdownData] = useState({});
  const [dropdownPropsTabData, setdropdownPropsTabData] = useState([]);
  const [allRolesData, setAllRolesData] = useState([]);
  const [allCompletionRuleData, setAllCompletionRuleData] = useState([]);
  const isRoleChangedRef = useRef(false);
  const isCompletionRulesRef = useRef(false);
  const isEventDeletedRef = useRef(false);
  const templateIdRef = useRef(subflowTempId);
  const isEditWorkflowRef = useRef(isEditSubflow);
  const [confirmPopupData, setConfirmPopupData] = useState({
    title: 'Confirm Permission Changes',
    popupType: 'Yes',
    name: ''
  });
  const [levelNames, setlevelNames] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isWorkflowChanged, setIsWorkflowChanged] = useState(false);
  const subflowTempcont = new SubflowTemplateServiceController();
  const isSelectedWorkflowEmpty = selectedValues.selectedWorkflow.label === "--select--";
  const isSelectedLevelEmpty = selectedValues.selectedLevel.label === "--select--";
  const [isNoLevelPopup, setIsNoLevelPopup] = useState(false);
  const [propPermission, setPropPermission] = useState('');
  const [sequenceNumber, setSequenceNumber] = useState(0);
  const [addsequenceNumber, setAddSequenceNumber] = useState([]);

  const [isOpenCalloutNamePop, setIsOpenCalloutNamePop] = useState(false);
  const [calloutName, setCalloutName] = useState();
  const [calloutNameWorkFlowTemplate, setCalloutNameWorkFlowTemplate] = useState();
  const [selectedVersionId, setSelectedVersionId] = useState();
  const [modifiedJson, setModifiedJson] = useState();
  const [reloadSubflowTemplate, setReloadSubflowTemplate] = useState(0);

  const reloadSubflowTemplateCanvas = () => {
    setReloadSubflowTemplate(prev => prev + 1);
  };

  const handleSelectChanges = (selectedValue, dropdownId) => {
    setSelectedValues(prevValues => ({
      ...prevValues,
      [dropdownId]: selectedValue
    }));
    if (dropdownId === 'selectedWorkflow') {
      setWorkFlowId(selectedValue.dropdownId);
      setIsWorkflowChanged(true);
      setSelectedVersionId(selectedValue.versionId);
      setCalloutNameWorkFlowTemplate(selectedValue.calloutName);
    } else if (dropdownId === 'selectedLevel') {
      setIsWorkflowChanged(true);
    }
    else {
      setIsWorkflowChanged(true);
    }
  };

  useEffect(() => {
    if (workFlowId && calloutNameWorkFlowTemplate) {
      handleVersionChange(selectedVersionId);
    }
  }, [workFlowId], [calloutNameWorkFlowTemplate]);

  const handleSelectEventLevelChanges = (selectedValue, dropdownId) => {
    reloadSubflowTemplateCanvas();
    setSelectedValues(prevValues => ({
      ...prevValues,
      [dropdownId]: selectedValue
    }));
    if (dropdownId === 'selectedLevel') {
      setLevelId(selectedValue.dropdownId);
      setIsWorkflowChanged(true);
      updateNodesWithIncomingData(selectedValue.dropdownId);
    }
    else {
      setIsWorkflowChanged(true);
    }
  };

  const updateNodesWithIncomingData = async (levelId) => {
    const body = await subflowTempcont.getSelectedEventsBySkillLevel(levelId);
    setEventLevelDropdownData(body);
  }
  useEffect(() => {
    if (workflowCanvasRef.current) {
    }
  }, [json]);

  useEffect(() => {
    const dropdownId = selectedValues?.selectedLevel?.dropdownId;
    if (subflowTempId !== "0" && dropdownId && dropdownId !== "0") {
      updateNodesWithIncomingData(dropdownId);
    }
  }, [subflowTempId, selectedValues?.selectedLevel?.dropdownId]);

  function uint8ArrayToBase64(uint8Array) {
    let binary = '';
    const len = uint8Array.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return window.btoa(binary);
  }

  const generalValidationsOnSave = () => {
    if (workflowCanvasRef.current) {
      const emptyCanvas = workflowCanvasRef.current.checkEmptyDiagram();
      const emptyNodes = workflowCanvasRef.current.checkEmptyNodes();
      if (isSelectedWorkflowEmpty || isSelectedLevelEmpty) {
        //console.log(workFlow,level,emptyNodes);
        notify(`Please select Workflow & Level dropdown values before saving`, false);
        return false;
      }
      else if (emptyCanvas) {
        notify(`There is no flow template to save.`, false);
        return false;
      }
      else if (emptyNodes) {
        notify(`There cannot be empty nodes in the diagram`, false);
      }
      return true;
    }
  }

  const handleOnSave = async () => {
    const hasAnyPermission = allRolesData.some(role => role.isView || role.isAdd || role.isEdit || role.isExecute);
    if (!hasAnyPermission) {
      notify(
        "Please select at least one permission setting to save the template.",
        false
      );
      return;
    }

    if (isRoleChangedRef.current) {
      setConfirmPopupData(prev => ({
        ...prev,
        title: "Unsaved Changes",
        popupType: "Ok",
        name: `You have unsaved permission changes for '${levelNames}'. Do you want to save before continuing?`
      }));
      setIsPopupOpen(true);
      return;
    }
    if (isEditSubflow == false)
      setIsOpenCalloutNamePop(true);
    else
      handleSaveInputCalloutName();
  };

  const apiData = [
    { label: "Add candidate info", OrderBy: "1" },
    { label: "Move to next stage", OrderBy: "2" },
    { label: "Schedule HR call with candidate", OrderBy: "3" },
    { label: "Send Tech Self Eval QRE to Candidate", OrderBy: "5" },
    { label: "Remind Hiring Manager (Approve/Reject)", OrderBy: "6" }
  ];

  const reorderCanvasByApi = (canvasJson, apiData) => {
    // ✅ Step 0: Parse if string
    const parsedCanvas =
      typeof canvasJson === "string"
        ? JSON.parse(canvasJson)
        : canvasJson;

    const nodes = Array.isArray(parsedCanvas?.nodes)
      ? parsedCanvas.nodes
      : [];

    // Step 1: Create lookup
    const orderMap = {};
    apiData.forEach(item => {
      orderMap[item.eventName] = Number(item.orderBy);
    });

    // Step 2: Sort
    const sortedNodes = [...nodes].sort((a, b) => {
      const orderA = orderMap[a?.data?.label] ?? Infinity;
      const orderB = orderMap[b?.data?.label] ?? Infinity;
      return orderA - orderB;
    });

    // Step 3: Update position
    const updatedNodes = sortedNodes.map((node, index) => ({
      ...node,
      position: {
        ...node.position,
        x: 12,
        y: index * 64,
      },
    }));

    return {
      ...parsedCanvas,
      nodes: updatedNodes,
    };
  };

  useEffect(() => {
    if (modifiedJson) {
      workflowCanvasRef.current.importFromJson?.(modifiedJson);
    }
  }, [modifiedJson]);

  const alignDiagram = async () => {
    const locSubflowTempId = subflowTempId && subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0;
    const bodyApiData = await subflowTempcont.getEventWithOrderBy(locSubflowTempId);
    if (bodyApiData) {
      const exportedData = workflowCanvasRef.current.exportToJson();
      const modifiedJson = reorderCanvasByApi(exportedData, bodyApiData);
      setModifiedJson(modifiedJson);
      // optional: update canvas immediately if importFromJson exists
      workflowCanvasRef.current.importFromJson?.(modifiedJson);
    }
  }

  const handleSaveInputCalloutName = async () => {
    const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
    setWorkflowData(exportedData);

    if (exportedData) {
      // Now save the exported data
      const svgImg = await workflowCanvasRef.current.exportToSVG();
      const base64String = uint8ArrayToBase64(svgImg);
      let exportedJsonData = exportedData;
      if (typeof exportedData === "string") {
        exportedJsonData = JSON.parse(exportedData);
      }

      let finalCalloutName;
      if (isCloneSubflow) {
        finalCalloutName = calloutName ?? "";
      } else if (subflowReqBody.calloutName != null) {
        finalCalloutName = subflowReqBody.calloutName;
      } else {
        finalCalloutName = calloutName ?? "";
      }

      const getJsonData = async () => {
        document.getElementById('loadingOverlay').style.display = 'flex';
        const jsonData = {
          id: subflowTempId && subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0,
          workFlowTemplateId: selectedValues.selectedWorkflow.dropdownId,
          levelId: selectedValues.selectedLevel.dropdownId,
          levelName: selectedValues.selectedLevel.value,
          templateData: exportedJsonData,
          calloutName: finalCalloutName,
          //calloutName_WorkFlow: subflowReqBody.calloutName_WorkFlow,
          createOrModifiedBy: subflowReqBody.createOrModifiedBy,
          date: subflowReqBody.date,
          isActive: subflowReqBody.isActive,
          isPublished: subflowReqBody.isPublished,
          createdBy: subflowReqBody.createdBy,
          createdDate: subflowReqBody.createdDate,
          previewFileName: "string",
          diagram: base64String,
          mode: isCloneSubflow ? "isClone" : (isEditSubflow || isEditWorkflowRef.current) ? "isEdit" : "",
          versionId: selectedVersionId,
        };
        const body = await subflowTempcont.addEditSubflowTemplate(jsonData);
        document.getElementById('loadingOverlay').style.display = 'none';
        // Normalize response to avoid casing issues
        const success = body?.isSuccess ?? body?.isSuccess ?? false;
        const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();
        const tempWorkflowSubName = body?.templateName || subflowTemplateName;

        if (success) {
          if (message.toLowerCase().includes("only one clone")) {
            notify(
              message
                ? `${message} or Please modify to clone.`
                : "Please modify to clone.",
              false
            );
          } else {
            setSubflowTemplateName(tempWorkflowSubName); // 👈 better than message
            notify(
              `${tempWorkflowSubName} has been successfully ${isCloneSubflow ? "Cloned" : isEditSubflow ? "updated" : "Saved"}`,
              true
            );
            if (isCloneSubflow == true || isEditSubflow == true || isEditWorkflowRef.current == true) {
              setTimeout(async () => {
                onBackClick();
              }, 2500);
            }
            else if (isCloneSubflow == false && isEditSubflow == false) {
              // This function will inserting first time.
              templateIdRef.current = body?.id;
              isEditWorkflowRef.current = true;
              subflowTempId = body?.id;
              await onSaveRoleAccessAfterSubflowTemplate(body?.id); // Calling to save permission settings.              
            }
          }
        } else {
          notify(message || "There was an error while saving the workflow template.", false);
        }
      }
      getJsonData();
    }
  }

  useEffect(() => {
    setSelectedVersionId(subflowReqBody.versionId);
    setCalloutNameWorkFlowTemplate(subflowReqBody.templateName_WorkFlow);
  }, [confirmPopupData]);

  useEffect(() => {
    if (levelNames) {
      setConfirmPopupData(prev => ({
        ...prev,
        name: `Please save the role permission changes for '${levelNames}' before proceeding or cancel the changes,`
      }));
    }
  }, [levelNames]);

  const handleSelectChange = (event, type) => {
    if (type === 'workflow') {
      setWorkFlow(event.target.value);
      const selectedIndex = event.target.selectedIndex;
      const selectedOptionId = event.target.options[selectedIndex].id;
      setWorkFlowId(selectedOptionId);
    }
    else {
      setLevel(event.target.value);
      const selectedIndex = event.target.selectedIndex;
      const selectedOptionId = event.target.options[selectedIndex].id;
      setLevelId(selectedOptionId);
    }
  };

  const permissionData = [
    "Account",
    "Super Admin",
    "HR Manager",
    "HR Recruiter",
    "Hiring Manager",
    "External Vendor",
    "General User",
  ];

  const getAllRoles = async () => {
    const body = await subflowTempcont.getAllRoles();
    const formattedRoles = Array.isArray(body)
      ? body.map((role) => ({
        role_Mstr_Name: role.role_Mstr_Name,
        role_Mstr_ID: role.role_Mstr_Code,
      }))
      : [];
    setAllRolesData(formattedRoles);
  };

  useEffect(() => {
    if (isSelectedLevelEmpty || isSelectedWorkflowEmpty) {
      setEmptyDropdown(true);
    } else {
      setEmptyDropdown(false);
      setDropdownData({
        "client": { label: "--select--", value: "--select--", dropdownId: "0" },
        "department": { label: "--select--", value: "--select--", dropdownId: "0" },
        "workflowName": selectedValues.selectedWorkflow,
        "level": selectedValues.selectedLevel,
      });
    }
  }, [selectedValues], [propPermission]);

  const imgForPreview = () => {
    const svgImg = workflowCanvasRef.current.exportToSVG();
    setSvgData(svgImg);
  }
  const handleInputCalloutName = (event) => {
    setSubflowTemplateName(event.target.value);
  }

  const openNoLevelsPopup = () => {
    setIsNoLevelPopup(!isNoLevelPopup);
  }

  const [selectedRoles, setSelectedRoles] = useState({});
  const handleChange = (roleId) => {
    setSelectedRoles((prev) => ({
      ...prev,
      [roleId]: !prev[roleId],
    }));
  };

  const handlePermissionChange = (roleId, permissionKey) => {
    isRoleChangedRef.current = true;

    setAllRolesData(prev =>
      prev.map(role => {
        if (role.id !== roleId) return role;

        return {
          ...role,
          [permissionKey]: !role[permissionKey]
        };
      })
    );
  };

  const handleNodeDeleted = async () => {
    isEventDeletedRef.current = true;
  }
  const [rulesList, setRulesList] = useState([]);
  const [eventFieldList, setEventFieldList] = useState([]);

  const handleNodeSelection = async (node) => {
    try {
      if (isRoleChangedRef.current) {
        setIsPopupOpen(true);
        return;
      }
      document.getElementById('loadingOverlay').style.display = 'flex';
      const newId = Number(node?.id) + 1;
      const labelName = node?.data?.label;
      const eventId = node?.data?.eventId;
      const subworkflowId = subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0;
      const workflowType = "SF";
      seteventId(eventId);
      setlabelNames(labelName);
      // // 1️⃣ Fetch data
      const bodyallWorkFlowPermission = await subflowTempcont.getWorkFlowPermissionById(subworkflowId, workflowType, eventId); // array of permissions
      const bodyallRolesData = await subflowTempcont.getAllRoles(); // array of roles
      const formattedRoles = Array.isArray(bodyallRolesData)
        ? bodyallRolesData.map((role) => ({
          role_Mstr_Name: role.role_Mstr_Name,
          id: role.role_Mstr_Code
        }))
        : [];
      // Flatten all workFlowPermissionStatus from body2
      // 3️⃣ Create permission map
      const permissionMap = new Map(bodyallWorkFlowPermission.map(p => [p.roleId, p]));
      // 4️⃣ Merge roles + permissions
      const updatedRoles = formattedRoles.map(role => {
        const permissionSetValue = permissionMap.get(role.id);
        const flatPermissions = permissionMap.permission;
        return {
          ...role,
          isView: permissionSetValue?.isView ?? false,
          isAdd: permissionSetValue?.isAdd ?? false,
          isEdit: permissionSetValue?.isEdit ?? false,
          isDelete: permissionSetValue?.isDelete ?? false,
          isExecute: permissionSetValue?.isExecute ?? false
        };
      });
      // 5️⃣ Update state
      const ispermissioValues = bodyallWorkFlowPermission[0]?.permission || null;
      const sequenceNumberValues = bodyallWorkFlowPermission[0]?.orderBy || newId;
      setPropPermission(ispermissioValues);
      setSequenceNumber(sequenceNumberValues);
      if (workflowCanvasRef.current) {
        const flowData = workflowCanvasRef.current.exportToJson();
        if (flowData) {
          const parsedData = JSON.parse(flowData);
          const levels = parsedData?.nodes?.map(node => ({
            id: node?.data?.eventDetails?.eventId,
            calloutName: node?.data?.eventDetails?.primaryEventName,
            displayName: node?.data?.eventDetails?.selectedEventName,
            mappedsubflowId: node?.data?.eventDetails?.eventId
          })) || [];
          setdropdownPropsTabData(levels);
          const sequenceData = parsedData?.nodes?.map((node, index) => ({
            id: node?.data?.eventDetails?.eventId,
            sequenceNumber: index + 1 // 👈 sequence
          })) || [];
          setAddSequenceNumber(sequenceData);
        }
      }

      setAllRolesData(updatedRoles);
      if (subworkflowId !== null && subworkflowId !== 0) {
        await getAllCompletionRule(subworkflowId, eventId);
      }

      const response = await subflowTempcont.getRulesEventRule(eventId);

      setRulesList(
        response?.map((rule) => ({
          id: rule.id,
          callOutName: rule.callOutName,
          name: rule.constraintValue,
          constraintId: rule.workFlowEventConstraintId,   // 👈 important
          constraint: rule.workFlowEventConstraint,       // 👈 optional (label)
          constraintValueId: rule.constraintValueId
        })) || []
      );

      document.getElementById('loadingOverlay').style.display = 'none';
    } catch (error) {
      document.getElementById('loadingOverlay').style.display = 'none';
      console.error("Error fetching workflow permissions:", error);
    }
  };

  const getAllCompletionRule = async (subworkflowId, eventId) => {
    const response = await subflowTempcont.getCompletionRulesBySubflowId(subworkflowId, eventId); // array of permissions    
    const rules = response?.rules || [];
    const conditions = response?.conditions || [];
    // ✅ Merge Rules + Conditions → UI format
    const mappedRules = rules.map((rule, index) => ({
      id: rule.id,
      ruleEngine1EventId: Number(rule.ruleEngine1EventId),
      ruleEngine2EventId: Number(rule.ruleEngine2EventId),
      conditionRule: rule.logicalOperator || "EQUAL",
      // 👇 BETWEEN operator
      nextCondition:
        index < conditions.length
          ? conditions[index]?.condition
          : undefined,
    }));
    console.log("Mapped Rules (Parent):", mappedRules);
    setAllCompletionRuleData(mappedRules);
  }

  const onSaveRoleAccess = async () => {
    if (!templateIdRef.current || templateIdRef.current === 0) {
      isRoleChangedRef.current = false;
      await handlePermissionTabToSaveSubflowTemplate();
    } else {
      await onSaveRoleAccessAfterSubflowTemplate(); // Calling to save permission settings. 
    }
  };

  // Callback to receive value from child
  const handleOrderByChange = (value) => {
    setSequenceNumber(value);
    console.log("Received from child:", value);
  };

  const onSaveRoleAccessAfterSubflowTemplate = async () => {
    const loclevelId = eventId; // current node levelId
    const subflowTemplateId = subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0;
    const workflowType = "SF";
    const workFlowPermissionStatus = allRolesData
      .filter(role => role.isView || role.isAdd || role.isEdit || role.isDelete || role.isExecute)
      .map(role => ({
        id: 0,
        workFlowPermissionId: 1,
        roleId: role.id,
        isView: !!role.isView,
        isAdd: !!role.isAdd,
        isEdit: !!role.isEdit,
        isDelete: !!role.isDelete,
        isExecute: !!role.isExecute
      }));

    const workFlowPermissionDto = {
      id: 0,                        // workflow permission id; set dynamically if needed
      workflowType: workflowType,
      templateId: subflowTemplateId,
      levelEventId: loclevelId,
      workFlowPermissionStatus: workFlowPermissionStatus,
      orderBy: sequenceNumber
    };
    const body = await subflowTempcont.postAddUpdateWorkFlowPermission(workFlowPermissionDto);
    await notify(`${labelName} ${body}`, true);
    setSelectedRoles({});
    isRoleChangedRef.current = false;
  };

  const onSaveConstraints = async ({ completionRules, node, onUpdateNode }) => {
    if (!completionRules.ruleName.trim()) {
      await notify("Please enter a rule name.", false);
      return;
    }
    const errors = validateCompletionRules(completionRules);
    if (errors !== null && errors !== undefined && errors.length > 0) {
      await notify(errors, false);
    }
    else {
      if (!templateIdRef.current || templateIdRef.current === 0) {
        isCompletionRulesRef.current = true;
        await handleAdvanceTabToSaveSubflowTemplate(completionRules, node, onUpdateNode);
      }
      else {
        await onSaveConstraintsAfterWorkflowTemplate(completionRules, node, onUpdateNode);
      }
    }
  };

  // const onReorderSequence = async ({ id, sequenceNumber, nodeId }) => {
  //   debugger;
  //   if (!id || !sequenceNumber) {
  //     await notify("Please select a sequence.", false);
  //     return;
  //   }

  //   console.log("Reorder Data:", {
  //     eventId,
  //     sequenceNumber,
  //     nodeId
  //   });
  //   // 👉 API call example
  //   // await updateSequence({ id, sequenceNumber, nodeId });
  //   debugger;
  // };
  const onReorderSequence = async ({ id, sequenceNumber, nodeId }) => {
    const subworkflowtemplateId = subflowTempId && subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0;
    if (subworkflowtemplateId === 0) {
      await notify("Please Create Subflow Template", false);
      return true;
    }
    const newPosition = Number(sequenceNumber);
    const currentItem = addsequenceNumber.find(item => item.id === eventId);
    if (!currentItem) return;
    if (currentItem.sequenceNumber === newPosition) {
      console.log("No change in position");
      return;
    }

    let list = [...addsequenceNumber];
    const movingIndex = list.findIndex(item => item.id === eventId);
    const movingItem = { ...list[movingIndex] };
    list.splice(movingIndex, 1);
    list.splice(newPosition - 1, 0, movingItem);

    const updatedList = list.map((item, index) => ({
      ...item,
      sequenceNumber: index + 1,
      templateId: subworkflowtemplateId
    }));

    console.log("After:", updatedList);

    const response = await subflowTempcont.updateSubFlowOrder(updatedList);
    if (response.Success === true) {
      // ✅ Align diagram AFTER update
      await alignDiagram();
    }
  };

  const onSaveConstraintsAfterWorkflowTemplate = async (completionRules, node, onUpdateNode) => {
    const requestDto = {
      SubFlowTemplateId: subflowTempId && subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0,
      EventId: eventId,
      RuleName: completionRules.ruleName, // include this
      Conditions: (completionRules.subflowRules ?? []).slice(0, -1).map((rule, index) => ({
        Id: index + 1,
        //DependsOn: index + 1, // adjust if backend expects different
        Condition: rule.nextCondition || "AND"
      })),
      Rules: (completionRules.subflowRules ?? [])
        .filter(c => c.ruleEngine1EventId != null && c.ruleEngine2EventId != null)
        .map((cond, index) => ({
          Id: index + 1,
          LogicalOperator: cond.conditionRule || "EQUAL",
          RuleEngine1EventId: Number(cond.ruleEngine1EventId),
          RuleEngine2EventId: Number(cond.ruleEngine2EventId),
        })),
    };
    if (onUpdateNode && node) {
      onUpdateNode({
        ...node.data,
        completionRules
      });
    }
    const body = await subflowTempcont.postAddUpdateSFCompletionRule(requestDto);
    const success = body?.isSuccess ?? body?.isSuccess ?? false;
    const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();
    if (success) {
      await notify(`${labelName} ${message}`, true);
    }
    else {
      await notify(`${labelName} ${message}`, false);
    }
    isCompletionRulesRef.current = false;
  }

  function validateCompletionRules(data) {
    if (!data) {
      return "completionRules is missing";
    }

    // RuleName
    if (typeof data.ruleName !== "string" || data.ruleName.trim() === "") {
      return "RuleName is required";
    }

    // subflowRules
    // Rules Array
    if (!Array.isArray(data.subflowRules) || data.subflowRules.length === 0) {
      return "At least one rule is required";
    }
    const seenRules = new Set();

    for (let i = 0; i < data.subflowRules.length; i++) {
      const rule = data.subflowRules[i];

      if (!rule) {
        return `Rule[${i}] is undefined/null`;
      }

      if (rule.ruleEngine1EventId == null || String(rule.ruleEngine1EventId).trim() === "" || String(rule.ruleEngine1EventId).trim() === "Select Constraint Field" || String(rule.ruleEngine1EventId).trim() === "0") {
        return `Constraint Field[${i}] → is required`;
      }

      if (rule.ruleEngine2EventId == null || String(rule.ruleEngine2EventId).trim() === "" || String(rule.ruleEngine2EventId).trim() === "Possible Constraint Values" || String(rule.ruleEngine2EventId).trim() === "0") {
        return `Constraint Value[${i}] → is required`;
      }

      const operator = rule.conditionRule ?? rule.condition;
      if (typeof operator !== "string" || operator.trim() === "") {
        return `Constraint[${i}] → Logical Operator is required`;
      }

      // Duplicate check
      const key = `${rule.ruleEngine1EventId}-${rule.ruleEngine2EventId}-${operator}`;
      console.log("rule key", key);
      if (seenRules.has(key)) {
        return `Rule[${i}] → Duplicate rule not allowed`;
      }
      seenRules.add(key);
    }

    const conflictError = validateConflicts(data.subflowRules);
    if (conflictError)
      return conflictError;
    return null; // ✅ no errors
  }

  function validateConflicts(rules) {
    const normalize = (op) => {
      if (op === "LessThan") return "<";
      if (op === "GreaterThan") return ">";
      return op;
    };

    for (let i = 0; i < rules.length; i++) {
      for (let j = i + 1; j < rules.length; j++) {
        const r1 = rules[i];
        const r2 = rules[j];

        // ✅ same field check
        if (r1.ruleEngine1EventId !== r2.ruleEngine1EventId) continue;

        // ✅ normalize operator
        const op1 = normalize(r1.conditionRule);
        const op2 = normalize(r2.conditionRule);

        // ✅ treat ruleEngine2EventId as value
        const val1 = Number(r1.ruleEngine2EventId);
        const val2 = Number(r2.ruleEngine2EventId);

        // ✅ check AND connection (important fix)
        const isAND =
          (r1.nextCondition && r1.nextCondition.toUpperCase() === "AND") ||
          (r2.nextCondition && r2.nextCondition.toUpperCase() === "AND");

        if (!isAND) continue;

        // 🔥 EXACT conflict: < X AND > X
        if (
          (op1 === "<" && op2 === ">" && val1 === val2) ||
          (op1 === ">" && op2 === "<" && val1 === val2)
        ) {
          return `❌ Conflict between Rule[${i}] & Rule[${j}] → value cannot be both < and >`;
        }
      }
    }
    return null;
  }

  const handleAdvanceTabToSaveSubflowTemplate = async (completionRules, node, onUpdateNode) => {
    const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
    setWorkflowData(exportedData);

    if (exportedData) {
      // Now save the exported data
      const svgImg = await workflowCanvasRef.current.exportToSVG();
      const base64String = uint8ArrayToBase64(svgImg);
      let exportedJsonData = exportedData;
      if (typeof exportedData === "string") {
        exportedJsonData = JSON.parse(exportedData);
      }

      const getJsonData = async () => {
        document.getElementById('loadingOverlay').style.display = 'flex';
        const jsonData = {
          id: subflowTempId && subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0,
          workFlowTemplateId: selectedValues.selectedWorkflow.dropdownId,
          levelId: selectedValues.selectedLevel.dropdownId,
          levelName: selectedValues.selectedLevel.value,
          templateData: exportedJsonData,
          createOrModifiedBy: subflowReqBody.createOrModifiedBy,
          date: subflowReqBody.date,
          isActive: subflowReqBody.isActive,
          isPublished: subflowReqBody.isPublished,
          createdBy: subflowReqBody.createdBy,
          createdDate: subflowReqBody.createdDate,
          previewFileName: "string",
          diagram: base64String,
          mode: isCloneSubflow ? "isClone" : (isEditSubflow || isEditWorkflowRef.current) ? "isEdit" : "",
          versionId: selectedVersionId,
        };
        const body = await subflowTempcont.addEditSubflowTemplate(jsonData);
        document.getElementById('loadingOverlay').style.display = 'none';
        // Normalize response to avoid casing issues
        const success = body?.isSuccess ?? body?.isSuccess ?? false;
        const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();
        if (success) {
          // This function will inserting first time.
          templateIdRef.current = body?.id;
          isEditWorkflowRef.current = true;
          subflowTempId = body?.id;
          await onSaveConstraintsAfterWorkflowTemplate(completionRules, node, onUpdateNode); // Calling to save permission settings.       

        } else {
          notify(message || "There was an error while saving the workflow template.", false);
        }
      }
      getJsonData();
    }
  }

  const handlePermissionTabToSaveSubflowTemplate = async () => {
    const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
    setWorkflowData(exportedData);

    if (exportedData) {
      // Now save the exported data
      const svgImg = await workflowCanvasRef.current.exportToSVG();
      const base64String = uint8ArrayToBase64(svgImg);
      let exportedJsonData = exportedData;
      if (typeof exportedData === "string") {
        exportedJsonData = JSON.parse(exportedData);
      }

      const getJsonData = async () => {
        document.getElementById('loadingOverlay').style.display = 'flex';
        const jsonData = {
          id: subflowTempId && subflowTempId !== 0 ? subflowTempId : templateIdRef.current ?? 0,
          workFlowTemplateId: selectedValues.selectedWorkflow.dropdownId,
          levelId: selectedValues.selectedLevel.dropdownId,
          levelName: selectedValues.selectedLevel.value,
          templateData: exportedJsonData,
          createOrModifiedBy: subflowReqBody.createOrModifiedBy,
          date: subflowReqBody.date,
          isActive: subflowReqBody.isActive,
          isPublished: subflowReqBody.isPublished,
          createdBy: subflowReqBody.createdBy,
          createdDate: subflowReqBody.createdDate,
          previewFileName: "string",
          diagram: base64String,
          mode: isCloneSubflow ? "isClone" : (isEditSubflow || isEditWorkflowRef.current) ? "isEdit" : "",
          versionId: selectedVersionId,
        };
        const body = await subflowTempcont.addEditSubflowTemplate(jsonData);
        document.getElementById('loadingOverlay').style.display = 'none';
        // Normalize response to avoid casing issues
        const success = body?.isSuccess ?? body?.isSuccess ?? false;
        const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();

        if (success) {
          // This function will inserting first time.
          templateIdRef.current = body?.id;
          isEditWorkflowRef.current = true;
          subflowTempId = body?.id;
          await onSaveRoleAccessAfterSubflowTemplate(); // Calling to save permission settings.       

        } else {
          notify(message || "There was an error while saving the workflow template.", false);
        }
      }
      getJsonData();
    }
  }

  const handleVersionChange = async (versionId) => {
    if (workFlowId !== "0" && versionId !== "0") {
      const subflowDropdowns = await subflowTempcont.getSubflowTemplateDropdownValuesLevels(workFlowId, versionId);
      setSelectedVersionId(versionId);
      setLevel(
        Array.isArray(subflowDropdowns) && subflowDropdowns.length > 0
          ? [
            { label: "--select--", value: "--select--", dropdownId: "0" }, // Initial department value
            ...subflowDropdowns.map((item) => ({
              label: item.levelName,
              value: item.levelName,
              dropdownId: item.id,
            })),
          ]
          : [
            {
              label: subflowDropdowns ?? "--select--",
              value: subflowDropdowns ?? "--select--",
              dropdownId: "0",
            },
          ] // Dummy option if body is empty
      );
    }
  };

  const handleInputChange = (event) => {
    setCalloutName(event.target.value);
  };

  const onClose = () => {
    setIsOpenCalloutNamePop(false);
  };

  return (
    <>
      <CanvasHeader
        handleSelectChange={handleSelectChanges}
        handleVersionChange={handleVersionChange}
        Level={Level}
        handleSelectEventLevelChanges={handleSelectEventLevelChanges}
        selectedValues={selectedValues}
        backClick={onBackClick}
        saveJson={handleOnSave}
        handleInputCalloutName={handleInputCalloutName}
        backButtonLabel={`Subflow Template List ${subflowTemplateName ? ` | Edit Subflow Template : ${subflowTemplateName}` : ''}`}
        client={workFlow}
        department={Level}
        isTransaction={false}
        isSubflow={true}
        event={false}
        fromSubflow={true}
        imgForPreview={imgForPreview}
        workFlowId={workFlowId}
        versionId={selectedVersionId}
        savedName={subflowTemplateName}
        isEdit={isEditSubflow}
        isClone={isCloneSubflow}
        openNoLevelsPopup={openNoLevelsPopup}
        isWorkflowChanged={isWorkflowChanged}
        saveValidations={generalValidationsOnSave}
        isSaveDialogOpen={null}
        closeDialog={null}
        calloutNameWorkFlowTemplate={calloutNameWorkFlowTemplate}
      />

      <WorkflowCanvasSub
        key={`${reloadSubflowTemplate}-1`}
        ref={workflowCanvasRef}
        workflow={false}
        json={json}
        isSubflow={true}
        isTransaction={false}
        dropdownData={dropdownData}
        dropdownEventData={dropdownEventLevelData}
        dropdownPropsTabData={dropdownPropsTabData}
        handleSubflowCanvasClick={handleSubflowCanvasClick}
        createEvent={createEvent}
        allRolesData={allRolesData}
        onSaveRoleAccess={onSaveRoleAccess}
        handlePermissionChange={handlePermissionChange}
        onParentNodeClick={handleNodeSelection}
        onParentNodeDeleted={handleNodeDeleted}
        onSaveConstraints={onSaveConstraints}
        onReorderSequence={onReorderSequence}
        allCompletionRule={allCompletionRuleData}
        eventField={eventFieldList}
        ruleEngineEvents={rulesList}
        propPermission={propPermission}
        sequenceNumber={sequenceNumber}
        sequenceNumberValues={addsequenceNumber}
        handleOrderByChange={handleOrderByChange}
        alignDiagram={alignDiagram}
      />

      <NoLevelPopup
        openConfirmationPopup={isNoLevelPopup}
        onClose={openNoLevelsPopup}
        handleClickRedirect={onBackClick}
      />
      <CalloutNamePopup
        open={isOpenCalloutNamePop}
        onClose={onClose}
        onSave={handleSaveInputCalloutName}
        handleInputChange={handleInputChange}
      />
      <CustomToaster />
      <LoadingOverlay />
    </>
  );
};

export default SubflowTemplateCreation;


